import React from 'react';

import styles from './style.scss';


const CatalogDescription = () => (
  <React.Fragment>
    <h2>О каталоге книг</h2>
    <div className={styles.columnsContainer}>
      <div className={styles.column}>
        <p className={styles.paragraph}>
          Каждый день в&nbsp;библиотеку MyBook поступают новинки.
          Это книги и&nbsp;аудиокниги всех жанров: классика и&nbsp;современная литература,
          переиздания и&nbsp;новые произведения популярных авторов. Наш каталог&nbsp;&mdash;
          это ветвистое дерево. Детективы, любовные романы, фэнтези, фантастика, научно-популярные
          и&nbsp;бизнес-книги&nbsp;&mdash; самые популярные жанры.
          Каждый раздел содержит в&nbsp;себе несколько категорий,
          которые распределяют произведения по&nbsp;темам и&nbsp;уточняют поиск нужных книг.
        </p>
        <p className={styles.paragraph}>
          В&nbsp;разделе современной прозы вы&nbsp;встретите Несбё и&nbsp;Акунина, Барнса и&nbsp;Токареву,
          Пелевина и&nbsp;Сорокина&nbsp;&mdash; весь
          спектр писателей, которые создают литературу сегодня. Шедевры Достоевского, Толстого, Бунина и
          Куприна&nbsp;&mdash; в&nbsp;разделе классической литературы.
          Многие из&nbsp;классических романов и&nbsp;рассказов можно читать бесплатно.
        </p>
        <p className={styles.paragraph}>
          Если у&nbsp;вас есть вопросы к&nbsp;самому себе, если вы&nbsp;хотите измениться или наладить отношения с
          близкими&nbsp;&mdash; обратитесь к&nbsp;книгам по&nbsp;психологии.
          Тысячи читателей ежедневно находят в&nbsp;них информацию,
          которая помогает улучшить качество жизни. Читать эти электронные книги удобно в&nbsp;любой ситуации,
          отмечая полезные мысли и&nbsp;возвращаясь к&nbsp;главному в&nbsp;своих заметках.
        </p>
      </div>
      <div className={styles.column}>
        <p className={styles.paragraph}>
          О&nbsp;том, как привести дела в&nbsp;порядок, все успевать, запоминать важное, презентовать и&nbsp;продавать,
          планировать и&nbsp;считать, рассказывают книги лучших российских издательств деловой литературы:
          &laquo;Манн, Иванов и&nbsp;Фербер&raquo;, &laquo;Альпина Паблишер&raquo;, &laquo;Эксмо&raquo;,
          &laquo;Олимп-Бизнес&raquo;, &laquo;Питер&raquo;.
          Эти книги помогают улучшить личную эффективность и&nbsp;работу всего коллектива.
        </p>
        <p className={styles.paragraph}>
          Что почитать, чтобы развлечься? Заходите в&nbsp;раздел детективов,
          любовных романов,фантастики и&nbsp;фэнтези. Там вы&nbsp;найдете
          новинки и&nbsp;классику любимых жанров. В&nbsp;MyBook каждый сможет выбрать
          книгу по&nbsp;душе, даже ребенок. Сказки, повести, обучающие пособия и&nbsp;поучительные
          рассказы подойдут для чтения в&nbsp;кругу семьи. Вы&nbsp;можете читать и&nbsp;слушать
          книги онлайн на&nbsp;сайте или в&nbsp;мобильном приложении даже без интернета.
        </p>
      </div>
    </div>
  </React.Fragment>
);

export default CatalogDescription;
